import React from 'react';
import '../../App.css';
import '../AboutMe.css'



export default function AboutMe(){
    return (
        <>
        <div className="aboutme">
            <h1 className='aboutme-title'>My Story</h1>
            <p className='aboutme-para'>My name is Kamsi Ben Agu. I am a second generation Nigerian-American who grew up in Virginia.<br/> As a child I was fascinated with technology and its capabilities but only decided to pursue software development<br/> during my sophmore year in highschool after an introductory programming class.<br/> This class sparked a drive in me for software handling, development, testing and writing.<br/> Since then I've continued to strengthen my skills through numerous coding camps, classes and projects<br/> which has given me proficiency in Python, Java, JS(React), HTML and CSS.<br/> Currently I'm at Northern Virginia Community College where I am pursuing my bachelors in Computer Science<br/> through hands-on classes taught by excellent professors.<br/><br/> As well as being a full time student I am also a part-time Lead Marketing Associate for a telepsychiatric organization<br/> in which I've created pages and social media platforms for my client.<br/> My goal is to enter this industry and to further my skills and abilities as a software developer.<br/><br/> This website was designed specifically to showcase my skills to recruiters and to solidify my position as an<br/> application candidate. Through browsing I hope for you to learn more about who I am, my values,<br/> my personal projects and how I can contribute to your team.</p>
                
    
          
        </div>
        
    
    </>
    )
}